import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetDashboardActivityInMinsInterface {
  startDate: string;
  endDate: string;
}

export const useGetDashboardActivityInMins = () => {
  const mutate = useMutation(({ startDate, endDate }: GetDashboardActivityInMinsInterface) => {
    return get(`/views-api/get_views_with_range/${startDate}/${endDate}`);
  });

  return mutate;
};

export default useGetDashboardActivityInMins;
